/*
 * *****************************************************************************
 * File: 404.js (/src/pages/404.js) | frontend
 * Written by Andrea Corsini <andrea@rs1.it>
 * =============================================================
 * Created on Sunday, 14th March 2021 5:26:12 pm
 *
 * Copyright (c) 2020-2021 Andrea Corsini T/A RS1 Project - All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * Modified on Wednesday, 31st March 2021 2:53:38 pm
 * *****************************************************************************
 */
import React from 'react'
import styled from '@emotion/styled'

const Page = () => (
    <>
        <Heading>404 - Pagina non trovata</Heading>
        <Content>
            Ops, purtroppo non c&apos;&egrave; nessun contenuto a questo
            indirizzo!
        </Content>
    </>
)
export default Page

const Heading = styled.h1`
    color: #ff3b30;
    margin: 0 0 15px;
`
const Content = styled.div`
    margin: 0;
    font-size: 15px;
    line-height: 1.3;
`
